/* eslint-disable max-len */
import React, {Component} from "react";
import {t, Trans} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {connect} from 'react-redux';
import {Button, Col, Form, Input, message, Row, Switch} from "antd";
import Drawer from 'bukku/components/Ant/Drawer';
import UserActions from 'bukku/redux/User/actions';
import {BukkuUpload} from "bukku/components/Upload";
import { IMAGE_ACCEPTED_MIMES } from 'bukku/components/Upload/constants';
import { QuestionCircleOutlined } from "@ant-design/icons";
import BukkuTooltip from "../../Tooltip";
import { PhoneNumberFormItem } from "../../FormItem/PhoneNumberFormitem";
// import { DialCodeInput } from "../../Input/DialCodeInput";
// import { DialCodeInputHelper } from '../../Input/DialCodeInputHelper';

const {
    readUser,
    updateUser,
} = UserActions;

const apiUrl = process.env.REACT_APP_PROXY_API_URL;

class UserView extends Component {
    formRef = React.createRef();
    // intlRef = React.createRef();

    componentDidUpdate(prevProps) {
        const {
            open,
            userUpdateState,
            userReadState,
            closeDrawer,
        } = this.props;

        // On open
        if (open && !prevProps.open)
            this.onPageLoad();

        if (userReadState === 'success' && prevProps.userReadState === 'request')
            this.initFormData();

        if (userUpdateState === 'success' && prevProps.userUpdateState === 'request') {
            closeDrawer();
            this.refreshUser(); // required for session idle modal to work correctly
        }
    }

    onPageLoad = () => {
        const { readUser } = this.props;

        // Load user data.
        readUser();
    };

    refreshUser = () => {
        const { readUser } = this.props;

        // Load user data.
        readUser();
    };

    initFormData = () => {
        const { user } = this.props;
        this.formRef.current?.setFieldsValue({
            email: user.email,
            phone_no: user.phone_no || '60',
            // phone_no: DialCodeInputHelper.parseNumber(user.phone_no).number,
            first_name: user.first_name,
            last_name: user.last_name,
            signature_file_id: user.signature_file_id,
            subscribe_newsletter: user.subscribe_newsletter,
            session_idle_lock: user.session_idle_lock,
        });
    };

    // Normalise data for comparison.
    normalizeData = data => ({
        email: data.email || null,
        phone_no: data.phone_no || null,
        first_name: data.first_name || null,
        last_name: data.last_name || null,
        signature_file_id: data.signature_file_id || null,
        subscribe_newsletter: data.subscribe_newsletter || false,
        session_idle_lock: data.session_idle_lock || false,
    });

    // Prepare form data based on current data, excluding lists (items & term items)
    prepareFormData = () => this.formRef.current.getFieldsValue();

    onCloseDrawer = () => {
        const {
            closeDrawer,
        } = this.props;

        closeDrawer();
    };

    onSubmit = () => {
        this.formRef.current.validateFields()
            .then(() => {
                // const isValidNumber = DialCodeInputHelper.handleSubmitValidation(this.formRef, this.intlRef);
                // if (isValidNumber)
                this.doSubmit();
            })
            .catch(() => {
                message.warning(t`Please check the fields highlighted in red.`);
                return false;
            });
    };

    doSubmit = () => {
        const { updateUser } = this.props;
        const formData = this.normalizeData(this.prepareFormData());

        updateUser(formData);
    };

    getDrawerFooter = () => {
        const {
            isPushing,
        } = this.props;

        return (
            <React.Fragment>
                <Button
                    onClick={this.onCloseDrawer}
                >
                    <Trans>Cancel</Trans>
                </Button>
                <Button
                    loading={isPushing}
                    onClick={this.onSubmit}
                    type="primary"
                    htmlType="submit"
                >
                    <Trans>Submit</Trans>
                </Button>
            </React.Fragment>
        );
    };

    // getStylingLabel = () => (
    //     <span>
    //         <Trans>
    //             (
    //             <a
    //                 href="https://www.markdownguide.org/cheat-sheet/"
    //                 target="_blank"
    //                 rel="noopener noreferrer"
    //             >
    //                 Styling Guide
    //             </a>
    //             )
    //         </Trans>
    //     </span>
    // );

    getHeaders = () => {
        const headers = {};
        const {
            accessToken,
        } = this.props;
        if (accessToken)
            headers.Authorization = `Bearer ${accessToken}`;
        return headers;
    };

    getApi = () => `${apiUrl}/user_files`;

    // setFormPhoneNo = value => {
    //     this.formRef.current.setFieldsValue({phone_no: value});
    // };

    render() {
        const {
            open,
            user,
        } = this.props;

        const overrideUploadProps = {
            accept: '.jpg,.jpeg,.png',
            openFileDialogOnClick: true,
            headers: this.getHeaders(),
            action: this.getApi,
        };

        return (
            <Drawer
                title={<Trans>My Profile</Trans>}
                placement="right"
                closable
                onClose={this.onCloseDrawer}
                open={open}
                destroyOnClose
                footer={this.getDrawerFooter()}
                onClick={e => e.stopPropagation()}
            >
                <Form layout="vertical" ref={this.formRef}>
                    {/* Dummy col for popupType to work */}
                    <Row
                        type="flex"
                    >
                        <Col span={24}>
                            <Form.Item
                                label={<Trans>Email Address</Trans>}
                                name="email"
                                rules={[
                                    {
                                        type: 'email',
                                        message: t`The email address is invalid.`,
                                    }, {
                                        required: true,
                                        message: t`Please enter your email address.`,
                                    }]}
                            >
                                <Input placeholder="john@example.com" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row
                        className="panel-row"
                        type="flex"
                        style={{position: 'relative', zIndex: 2}} // to prevent dropdown to be behind Upload .delete-btn
                    >
                        <Col span={24}>
                            <PhoneNumberFormItem />
                        </Col>
                    </Row>

                    <Row
                        type="flex"
                    >
                        <Col span={24}>
                            <Form.Item
                                label={<Trans>First Name</Trans>}
                                name="first_name"
                                rules={[{
                                    required: true,
                                    message: t`Please enter your first name.`,
                                }]}
                            >
                                <Input placeholder={t`John`} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row
                        type="flex"
                    >
                        <Col span={24}>
                            <Form.Item
                                label={<Trans>Last Name</Trans>}
                                name="last_name"
                                rules={[]}
                            >
                                <Input placeholder={t`Tan`} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row className="panel-row" type="flex" style={{position: 'relative', zIndex: 1}}>
                        <Col className="panel-item-col upload-form-item">
                            <Form.Item
                                label={
                                    (
                                        <>
                                            <Trans>Digital Signature</Trans>
                                            &nbsp;
                                            <BukkuTooltip
                                                title={
                                                    <>
                                                        <Trans>Upload your signature image here and it will appear on the PDFs.</Trans>
                                                        &nbsp;
                                                        <Trans>Please upload image with white or transparent background.</Trans>
                                                    </>
                                                }
                                                // popupType="drawer"
                                            >
                                                <QuestionCircleOutlined />
                                            </BukkuTooltip>
                                        </>
                                    )
                                }
                                name="signature_file_id"
                            >
                                <BukkuUpload
                                    acceptedMimes={IMAGE_ACCEPTED_MIMES}
                                    initialFileUrl={user.signature_file_url}
                                    overrideUploadProps={overrideUploadProps}
                                    openFileManagerOnClick={false}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row className="panel-row" type="flex">
                        <Col
                            className="panel-item-col"
                        >
                            <Form.Item
                                label={(
                                    <>
                                        <Trans>Bukku Newsletter</Trans>
                                        &nbsp;
                                        <BukkuTooltip
                                            title={<Trans> Subscribe to Bukku Newsletter to receive the latest updates to our products and ecosystem.</Trans>}
                                            // popupType="drawer"
                                        >
                                            <QuestionCircleOutlined />
                                        </BukkuTooltip>
                                    </>
                                )}
                                name="subscribe_newsletter"
                                valuePropName="checked"
                            >
                                <Switch
                                    checkedChildren={t`On`}
                                    unCheckedChildren={t`Off`}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row className="panel-row" type="flex">
                        <Col
                            className="panel-item-col"
                        >
                            <Form.Item
                                label={(
                                    <>
                                        <Trans>Session Idle Lock</Trans>
                                        &nbsp;
                                        <BukkuTooltip
                                            title={<Trans>Turn on to lock the screen after 2 hours of inactivity.</Trans>}
                                            // popupType="drawer"
                                        >
                                            <QuestionCircleOutlined />
                                        </BukkuTooltip>
                                    </>
                                )}
                                name="session_idle_lock"
                                valuePropName="checked"
                            >
                                <Switch
                                    checkedChildren={t`On`}
                                    unCheckedChildren={t`Off`}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Button
                        onClick={e => this.onSubmit(e)}
                        type="primary"
                        htmlType="submit"
                        style={{ display: 'none' }}
                    />

                </Form>
            </Drawer>
        );
    }
}
export default connect(state => ({
    isPushing: state.App.isPushing,
    userReadState: state.User.userReadState,
    userUpdateState: state.User.userUpdateState,
    user: state.User.user,
    accessToken: state.Auth.accessToken,
}), {
    readUser,
    updateUser,
})(withI18n()(UserView));
